/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SupportTicketMessageViewModel } from '../../models/support-ticket-message-view-model';

export interface SendNewMessage$Params {
      body?: {
'ticketID'?: number;
'message'?: string;
'isAdminView'?: boolean;
'markClientMessagesRead'?: boolean;
}
}

export function SendNewMessage(http: HttpClient, rootUrl: string, params?: SendNewMessage$Params, context?: HttpContext): Observable<StrictHttpResponse<SupportTicketMessageViewModel>> {
  const rb = new RequestBuilder(rootUrl, SendNewMessage.PATH, 'post');
  if (params) {
    rb.body(params.body, 'multipart/form-data');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<SupportTicketMessageViewModel>;
    })
  );
}

SendNewMessage.PATH = '/api/Tickets/SendNewMessage';
